import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, useFragment } from 'react-relay';
import classNames from 'classnames';

import dibsCss from 'dibs-css';

import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

import { type PdpSharedSellerAssociations_seller$key } from './__generated__/PdpSharedSellerAssociations_seller.graphql.ts';

const sellerFragment = graphql`
    fragment PdpSharedSellerAssociations_seller on Seller {
        tradeAssociations {
            serviceId
            displayName
        }
    }
`;

export const PdpSharedSellerAssociations: FC<{
    seller: PdpSharedSellerAssociations_seller$key;
    isCompact?: boolean;
}> = ({ seller: sellerRef, isCompact = false }) => {
    const { isMobile } = useServerVarsContext();
    const seller = useFragment(sellerFragment, sellerRef);
    const tradeAssociations = seller?.tradeAssociations;

    if (!tradeAssociations || !tradeAssociations.length) {
        return null;
    }

    return (
        <div
            className={classNames(
                dibsCss.mtSmall,
                dibsCss.mbMedium,
                dibsCss.ptXsmall,
                isCompact && [dibsCss.m0, dibsCss.pt0],
                {
                    [dibsCss.sassyFontBodyTypeHeavy]: isMobile,
                    [dibsCss.sassyFontBodySmallHeavy]: !isMobile,
                }
            )}
            data-tn="dealer-associations"
        >
            <FormattedMessage id="PdpSharedSellerInfo.associations" defaultMessage="Associations" />

            <div className={classNames(dibsCss.flex, dibsCss.flexCol)}>
                {tradeAssociations.map(association => {
                    const { displayName, serviceId } = association || {};

                    if (!displayName || !serviceId) {
                        return null;
                    }

                    return (
                        <span
                            key={serviceId}
                            className={
                                isMobile ? dibsCss.sassyFontBody : dibsCss.sassyFontBodySizeSmall
                            }
                        >
                            {displayName}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};
